// src/components/Page/News/Section.js
import React, { useState, useEffect } from 'react';
import { ReactComponent as IconNossoVoo } from '../../../assets/img/icon-nosso-voo.svg';
import { ReactComponent as IconCalendar } from '../../../assets/img/icon-calendar.svg';

const Section = ({ backgroundColor, children, showIcon = false }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const sectionStyle = {
    width: '100%',
    minHeight: '300px',
    padding: isMobile ? '40px 10px' : '40px 150px',
    backgroundColor: backgroundColor,
    position: 'relative'
  };

  const iconNVWrapperStyle = {
    position: 'absolute',
    left: isMobile ? '77%' : '42%',
    bottom: 0,
    transform: 'translateX(-50%)',
    zIndex: 1
  };

  const iconCWrapperStyle = {
    position: 'absolute',
    left: isMobile ? '85%' : '90%',
    top: '10px',
    transform: 'translateX(-50%)',
    zIndex: 1
  };

  return (
    <section style={sectionStyle}>
      {showIcon && (
        <>
          <div style={iconNVWrapperStyle}>
            <IconNossoVoo />
          </div>
          <div style={iconCWrapperStyle}>
            <IconCalendar />
          </div>
        </>
      )}
      {children}
    </section>
  );
};

export default Section;